import script from "./AuditorioV2.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditorioV2.vue?vue&type=script&setup=true&lang=js"

import "./AuditorioV2.vue?vue&type=style&index=0&id=eb9ef830&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb9ef830"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QVideo from 'quasar/src/components/video/QVideo.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QIcon,QToggle,QCard,QCardSection,QCarousel,QCarouselSlide,QImg,QSpinner,QScrollArea,QMarkupTable,QSeparator,QVideo});
